import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
}
export function Button({
  children,
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-block w-full md:w-auto text-center bg-brand-green hover:bg-brand-greenHover text-white font-bold py-4 px-8 rounded-lg shadow-lg transition-colors duration-300 text-lg md:text-xl';
  const content = <motion.div whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-1">
      {children}
    </motion.div>;
  if (href) {
    return <a href={href} className={`${baseStyles} ${className}`} data-id="element-2">
        {content}
      </a>;
  }
  return <button className={`${baseStyles} ${className}`} {...props} data-id="element-3">
      {content}
    </button>;
}